export default "__VITE_ASSET__t9FPu4FG__"